import { useEffect, useState } from 'react';

import * as S from './ToggleButtonGroup.styled';
import InfoTooltip from 'components/v2/common/infoTooltip';

type Props = {
    options: Array<string>;
    name: string;
    value: string | undefined;
    label: string;
    tooltip?: string;
    colForMobile?: boolean;
    familyMember?: boolean;
    customStyle?: boolean;
    onChange: (name: string, value: string) => void;
    error?: string;
};

const ToggleButtonGroup = ({
    options,
    name,
    value: valueProp,
    label,
    tooltip,
    onChange,
    error,
}: Props) => {
    const [value, setValue] = useState(valueProp);
    const hasError = Boolean(error);

    const handleClick = (val: string) => {
        setValue(val);
        onChange(name, val);
    };

    useEffect(() => {
        setValue(valueProp);
    }, [valueProp]);

    return (
        <S.ToggleBox>
            <S.ButtonGroupContainer>
                <S.ToggleButtonLabel>
                    {label}
                    {tooltip && <InfoTooltip title={tooltip} color="#686868" />}
                </S.ToggleButtonLabel>
                <S.ToggleButtonGroup role="group" aria-label={label}>
                    {options.map((option) => {
                        const selected = option === value;
                        return (
                            <S.ToggleButton
                                type="button"
                                key={option}
                                $selected={selected}
                                aria-pressed={selected}
                                onClick={() => handleClick(option)}
                            >
                                {option}
                            </S.ToggleButton>
                        );
                    })}
                </S.ToggleButtonGroup>
                {hasError && (
                    <S.ToggleValidationError role="alert">{error}</S.ToggleValidationError>
                )}
            </S.ButtonGroupContainer>
        </S.ToggleBox>
    );
};

export default ToggleButtonGroup;
